import type { Article } from '@/types';

export const articles: Article[] = [
  {
    id: 'a1',
    title: '悬疑黑马《长夜将明》定档暑期，主创阵容首次曝光',
    summary: '一部没有流量明星加持的悬疑片，却因扎实的剧本与冷峻的影像风格被业内称为暑期档最大变量。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20noir%20city%20street%20at%20night%20with%20rain%20and%20neon%20reflections%2C%20moody%20atmospheric%20film%20poster%20style%2C%20dark%20teal%20and%20amber%20tones%2C%20high%20detail%20dramatic%20lighting&width=800&height=600&seq=film-01-cover&orientation=landscape',
    category: 'film',
    categoryName: '影视',
    author: '编辑部',
    date: '2026-06-18',
    views: 18420,
    tags: ['悬疑', '定档', '暑期档'],
    hot: true,
    filters: { type: '电影', region: '内地', year: '2026' },
    content: [
      { type: 'paragraph', text: '当行业还在为暑期档的排片焦头烂额时，一部低调完成的悬疑电影《长夜将明》悄然锁定档期。没有铺天盖地的物料轰炸，取而代之的是一支三分钟的定性预告——冷雨、长街、一盏迟迟不肯熄灭的路灯，把悬念拉到了极致。' },
      { type: 'heading', text: '一场没有硝烟的心理博弈' },
      { type: 'paragraph', text: '影片讲述一名退休刑警被卷入一桩跨越二十年的旧案，随着调查深入，他发现真相比想象更加灰暗。《长夜将明》最迷人的地方并不在于反转，而在于人物在道德灰区里的缓慢挣扎。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=moody%20detective%20interrogation%20room%20with%20single%20hanging%20lamp%20and%20empty%20chair%2C%20cinematic%20suspense%20atmosphere%2C%20cool%20tonal%20palette%2C%20editorial%20photography&width=1200&height=700&seq=film-01-body&orientation=landscape', caption: '影片以克制的镜头语言营造压迫感' },
      { type: 'quote', text: '“我们不想拍一个炫技的悬疑，而是拍一个关于时间和救赎的故事。”——导演访谈' },
      { type: 'paragraph', text: '据悉，影片已入选多个电影节的展映单元，业内普遍看好其口碑发酵的潜力。对于渴望在爆米花大片之外寻找另一种观影体验的观众而言，《长夜将明》值得一张电影票。' },
    ],
  },
  {
    id: 'a2',
    title: '年度科幻巨制《星际回声》首支预告点燃期待',
    summary: '两分钟的预告里，人类第一次听到来自深空的回应。视觉奇观与哲学追问，让这部作品未映先热。',
    cover: 'https://readdy.ai/api/search-image?query=epic%20deep%20space%20nebula%20with%20lone%20spaceship%20silhouette%2C%20science%20fiction%20cinematic%20poster%2C%20rich%20purple%20and%20gold%20cosmic%20colors%2C%20high%20detail%20dramatic%20composition&width=800&height=600&seq=film-02-cover&orientation=landscape',
    category: 'film',
    categoryName: '影视',
    author: '张野',
    date: '2026-06-15',
    views: 26310,
    tags: ['科幻', '预告', '大片'],
    hot: true,
    filters: { type: '电影', region: '欧美', year: '2026' },
    content: [
      { type: 'paragraph', text: '当那段低频信号第一次在预告片尾响起，无数观众在弹幕里打下了“头皮发麻”。《星际回声》用一个极其克制的开场，把人类面对未知时的渺小与勇敢同时摆在了台面上。' },
      { type: 'heading', text: '技术之外，是人的选择' },
      { type: 'paragraph', text: '影片横跨三个星系拍摄，但导演反复强调，特效只是容器，真正的主角是那支在孤独航行中逐渐分崩离析的船员队伍。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=astronaut%20looking%20at%20vast%20glowing%20space%20station%20window%2C%20science%20fiction%20cinematic%20scene%2C%20cool%20blue%20and%20gold%20lighting%2C%20epic%20scale%2C%20editorial%20photography&width=1200&height=700&seq=film-02-body&orientation=landscape', caption: '深空中的孤独与壮丽' },
      { type: 'quote', text: '“如果宇宙真的有人在回应，我们准备好回答了吗？”——预告片尾字幕' },
      { type: 'paragraph', text: '业内预测，该片有望刷新同类型影片的票房纪录，而它带来的关于文明与沟通的讨论，或许会在上映后持续很久。' },
    ],
  },
  {
    id: 'a3',
    title: '都市剧《市井烟火》温暖收官，口碑逆袭成黑马',
    summary: '一部聚焦小人物生活的都市剧，靠真实质感与细腻表演，从开播时的低热度一路涨到收官口碑第一。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20cozy%20old%20city%20alley%20at%20dusk%20with%20lanterns%20and%20small%20shops%2C%20slice%20of%20life%20cinematic%20tone%2C%20warm%20amber%20and%20soft%20brown%20palette%2C%20high%20detail&width=800&height=600&seq=film-03-cover&orientation=landscape',
    category: 'film',
    categoryName: '影视',
    author: '林晚',
    date: '2026-06-12',
    views: 15230,
    tags: ['都市剧', '口碑', '收官'],
    hot: false,
    filters: { type: '电视剧', region: '内地', year: '2026' },
    content: [
      { type: 'paragraph', text: '《市井烟火》没有大场面，也没有强冲突，它只是安静地讲了几个普通人的一年。可正是这份安静，让无数观众在深夜里看得眼眶发热。' },
      { type: 'heading', text: '真实，是最强的戏剧张力' },
      { type: 'paragraph', text: '剧组在真实的社区取景，演员素颜出镜，台词里满是生活化的细碎。观众说，看这部剧像在看自己邻居家的故事。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=cozy%20family%20dinner%20table%20scene%20in%20small%20apartment%2C%20warm%20homey%20atmosphere%2C%20soft%20golden%20lighting%2C%20slice%20of%20life%20photography&width=1200&height=700&seq=film-03-body&orientation=landscape', caption: '烟火气里的生活质感' },
      { type: 'quote', text: '“日子不是熬过去的，是一天一天过出来的。”——剧中台词' },
      { type: 'paragraph', text: '收官当日，该剧相关话题冲上热搜前列，许多观众留言希望有第二季。慢热的作品，终于被看见了。' },
    ],
  },
  {
    id: 'a4',
    title: '导演陈屿新片入围国际电影节主竞赛单元',
    summary: '时隔四年，陈屿带着新作重返国际舞台。影片以一座逐渐消失的小镇为背景，探讨记忆与离开。',
    cover: 'https://readdy.ai/api/search-image?query=quiet%20foggy%20small%20town%20by%20the%20water%20at%20dawn%2C%20art%20house%20film%20poster%20style%2C%20muted%20desaturated%20tones%2C%20melancholic%20atmosphere%2C%20high%20detail&width=800&height=600&seq=film-04-cover&orientation=landscape',
    category: 'film',
    categoryName: '影视',
    author: '编辑部',
    date: '2026-06-09',
    views: 9840,
    tags: ['电影节', '文艺片', '陈屿'],
    hot: false,
    filters: { type: '电影', region: '内地', year: '2026' },
    content: [
      { type: 'paragraph', text: '当入围名单公布的那一刻，影迷圈沸腾了。陈屿的名字再次出现在国际电影节主竞赛单元，这距离他的上一部作品已经过去四年。' },
      { type: 'heading', text: '一座正在消失的小镇' },
      { type: 'paragraph', text: '新片把镜头对准了一个因水库建设而即将沉入水底的小镇。人物在拆迁与告别之间，重新审视自己与故乡的关系。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=abandoned%20waterfront%20town%20slowly%20submerging%20under%20calm%20water%2C%20art%20house%20cinematic%20landscape%2C%20pale%20muted%20blue%20grey%20tones%2C%20meditative%20mood&width=1200&height=700&seq=film-04-body&orientation=landscape', caption: '被水与时间一同淹没的故乡' },
      { type: 'quote', text: '“我想拍的不是告别，而是告别之前那一点点留恋。”——陈屿' },
      { type: 'paragraph', text: '影评人普遍认为，这部作品延续了陈屿一贯的诗意与克制，同时情感层次更加丰富，有望在奖项上有所斩获。' },
    ],
  },
  {
    id: 'a5',
    title: '经典IP《山海拾遗》官宣翻拍，概念海报梦幻首发',
    summary: '承载一代人记忆的《山海拾遗》宣布影视化，概念海报以水墨与光效结合，引发原著粉热议。',
    cover: 'https://readdy.ai/api/search-image?query=mythical%20chinese%20mountains%20and%20sea%20with%20glowing%20ink%20wash%20style%2C%20fantasy%20epic%20poster%2C%20deep%20indigo%20and%20gold%20accents%2C%20ethereal%20magical%20atmosphere%2C%20high%20detail&width=800&height=600&seq=film-05-cover&orientation=landscape',
    category: 'film',
    categoryName: '影视',
    author: '苏禾',
    date: '2026-06-05',
    views: 12980,
    tags: ['IP', '翻拍', '奇幻'],
    hot: false,
    filters: { type: '电视剧', region: '内地', year: '2026' },
    content: [
      { type: 'paragraph', text: '《山海拾遗》曾是无数人的枕边书，那些关于异兽与远方的想象，终于要在大银幕上活过来。官宣当天，概念海报就被转发了数十万次。' },
      { type: 'heading', text: '怎样还原读者心中的山海' },
      { type: 'paragraph', text: '制作方透露，剧组将采用实景与虚拟制作结合的方式，力求既保留东方美学的留白，又呈现足够的视觉冲击。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=mystical%20chinese%20ink%20painting%20landscape%20with%20floating%20islands%20and%20mist%2C%20fantasy%20concept%20art%2C%20serene%20celestial%20palette%2C%20highly%20detailed%20atmospheric&width=1200&height=700&seq=film-05-body&orientation=landscape', caption: '概念海报中的山海意象' },
      { type: 'quote', text: '“我们不打算复刻文字，而是想让观众重新做一场那个年代的梦。”——制片人' },
      { type: 'paragraph', text: '目前该项目已进入前期筹备，预计明年开机。原著粉最关心的选角与改编尺度，官方表示会“尊重核心，也拥抱变化”。' },
    ],
  },
  {
    id: 'a6',
    title: '暑期档票房破纪录，动画电影《风起云归》领跑',
    summary: '一部原创国产动画，用东方美学和动人故事杀出重围，成为今年暑期档最大的惊喜。',
    cover: 'https://readdy.ai/api/search-image?query=whimsical%20chinese%20animated%20sky%20with%20flowing%20clouds%20and%20flying%20birds%2C%20hand%20painted%20anime%20style%2C%20soft%20cyan%20and%20peach%20tones%2C%20dreamy%20atmosphere%2C%20high%20detail&width=800&height=600&seq=film-06-cover&orientation=landscape',
    category: 'film',
    categoryName: '影视',
    author: '张野',
    date: '2026-06-01',
    views: 21340,
    tags: ['动画', '票房', '暑期档'],
    hot: true,
    filters: { type: '电影', region: '内地', year: '2026' },
    content: [
      { type: 'paragraph', text: '当《风起云归》的首周末票房出来时，很多人都不敢相信自己的眼睛——一部没有IP、没有流量加持的原创动画，硬生生挤进了档期前列。' },
      { type: 'heading', text: '东方美学的一次成功落地' },
      { type: 'paragraph', text: '影片用水墨质感的画面讲述一个少年追寻归途的故事，慢节奏却充满力量，让成年观众也找回了看动画的纯粹快乐。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=young%20anime%20hero%20standing%20on%20cliff%20overlooking%20sea%20of%20clouds%20at%20sunrise%2C%20hand%20painted%20animation%20art%2C%20warm%20hopeful%20colors%2C%20cinematic%20wide%20shot&width=1200&height=700&seq=film-06-body&orientation=landscape', caption: '少年与云海的相遇' },
      { type: 'quote', text: '“我们想做的，是一部让人愿意再相信一次的电影。”——导演映后交流' },
      { type: 'paragraph', text: '截至目前，影片豆瓣评分稳定在 8 分以上，观众二刷三刷的比例明显高于同档期作品，被业内视为国产动画工业化的一次重要突破。' },
    ],
  },
  {
    id: 'b1',
    title: '林澈全新专辑《昼夜之间》上线，主打歌刷屏朋友圈',
    summary: '阔别两年，林澈带着十二首作品回归。这张专辑在深夜与黎明之间来回切换，被歌迷称为“成年人的情绪自白”。',
    cover: 'https://readdy.ai/api/search-image?query=moody%20album%20cover%20concept%20with%20split%20day%20and%20night%20cities%2C%20dreamy%20indie%20music%20aesthetic%2C%20warm%20amber%20meeting%20cool%20teal%2C%20soft%20grain%20texture%2C%20high%20detail&width=800&height=600&seq=music-01-cover&orientation=landscape',
    category: 'music',
    categoryName: '音乐',
    author: '橘子',
    date: '2026-06-16',
    views: 30120,
    tags: ['新专辑', '林澈', '流行'],
    hot: true,
    filters: { style: '流行', time: '本月' },
    content: [
      { type: 'paragraph', text: '凌晨零点，专辑准时上线。不到半小时，主打歌《昼夜之间》就冲上了各大平台的热搜榜。评论区里，有人说“终于等到了”，也有人说“这首歌写的就是我自己”。' },
      { type: 'heading', text: '在昼夜之间，安放成年人的情绪' },
      { type: 'paragraph', text: '整张专辑围绕“失去与和解”展开，林澈的声线比以往更松弛，也更真诚。制作上刻意保留了呼吸声与呼吸之间的空隙，让作品多了一层现场感。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=singer%20silhouette%20in%20studio%20surrounded%20by%20warm%20stage%20lights%2C%20music%20album%20session%20mood%2C%20amber%20and%20deep%20shadow%20tones%2C%20cinematic%20photography&width=1200&height=700&seq=music-01-body&orientation=landscape', caption: '录制现场的深夜时分' },
      { type: 'quote', text: '“这张专辑想说的是，白天要撑住，夜里可以哭一会儿。”——林澈' },
      { type: 'paragraph', text: '业内评价，这张专辑是林澈从“少年偶像”走向“成熟音乐人”的关键一步。实体黑胶预售也在开售后迅速售罄。' },
    ],
  },
  {
    id: 'b2',
    title: '独立乐队「拾光」巡演开票，三城门票秒罄',
    summary: '没有华丽的舞台，只有扎实的现场。这支从livehouse走出来的乐队，用十年时间等来了一场属于自己的巡演。',
    cover: 'https://readdy.ai/api/search-image?query=indie%20band%20performing%20on%20small%20intimate%20stage%20with%20warm%20lights%2C%20livehouse%20concert%20atmosphere%2C%20grainy%20film%20look%2C%20high%20detail&width=800&height=600&seq=music-02-cover&orientation=landscape',
    category: 'music',
    categoryName: '音乐',
    author: '阿南',
    date: '2026-06-13',
    views: 11240,
    tags: ['巡演', '独立乐队', '现场'],
    hot: false,
    filters: { style: '摇滚', time: '本季' },
    content: [
      { type: 'paragraph', text: '开票那天，很多乐迷守在手机前，结果三座城市的门票在几分钟内全部售罄。对他们来说，「拾光」不只是一支乐队，更是一段青春的背景音乐。' },
      { type: 'heading', text: '十年，从livehouse到大舞台' },
      { type: 'paragraph', text: '从最初只有几十人的场子，到如今一票难求，「拾光」几乎是靠口口相传走到了今天。他们的现场从不炫技，却总能让全场一起合唱。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=crowd%20singing%20along%20at%20indie%20concert%20with%20raised%20hands%2C%20warm%20stage%20lights%20and%20haze%2C%20energetic%20live%20music%20photography&width=1200&height=700&seq=music-02-body&orientation=landscape', caption: '全场大合唱的瞬间' },
      { type: 'quote', text: '“我们要的从来不是爆红，而是每一场都对得起买票的人。”——主唱' },
      { type: 'paragraph', text: '巡演将陆续在更多城市加场，主办方提醒乐迷认准官方渠道购票，谨防黄牛。' },
    ],
  },
  {
    id: 'b3',
    title: '说唱歌手Vico发布新单曲，联手国际制作人玩转新风格',
    summary: '这一次，Vico把方言与电子节拍揉在一起，交出了一首既本土又国际的作品，评论区好评如潮。',
    cover: 'https://readdy.ai/api/search-image?query=urban%20hip%20hop%20artist%20portrait%20with%20neon%20street%20lights%2C%20bold%20graphic%20single%20cover%20style%2C%20orange%20and%20deep%20charcoal%20tones%2C%20high%20contrast%2C%20high%20detail&width=800&height=600&seq=music-03-cover&orientation=landscape',
    category: 'music',
    categoryName: '音乐',
    author: '橘子',
    date: '2026-06-10',
    views: 18760,
    tags: ['说唱', '新歌', '跨界'],
    hot: true,
    filters: { style: '说唱', time: '本月' },
    content: [
      { type: 'paragraph', text: '新单曲上线首日，播放量就突破了千万。Vico这次大胆地把家乡方言写进副歌，配上国际制作人打造的电子节拍，意外地好听。' },
      { type: 'heading', text: '把方言唱给世界听' },
      { type: 'paragraph', text: '很多人以为方言说唱会劝退听众，但Vico用旋律证明了，真诚的表达反而更能打动人。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=rapper%20recording%20in%20modern%20studio%20with%20colorful%20LED%20accents%2C%20moody%20urban%20music%20scene%2C%20vibrant%20orange%20highlights%2C%20high%20detail&width=1200&height=700&seq=music-03-body&orientation=landscape', caption: '录音棚里的新尝试' },
      { type: 'quote', text: '“方言不是限制，是我最有辨识度的乐器。”——Vico' },
      { type: 'paragraph', text: '据悉，这首单曲将作为新专辑的先导曲，完整专辑预计在下半年与听众见面。' },
    ],
  },
  {
    id: 'b4',
    title: '华语金曲奖提名公布，新生代歌手强势入围',
    summary: '本届提名名单里，年轻面孔占据半壁江山。评审表示，华语乐坛正在经历一次安静而有力的换代。',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20gold%20music%20award%20trophy%20on%20dark%20stage%20with%20spotlight%2C%20prestigious%20awards%20ceremony%20atmosphere%2C%20warm%20gold%20and%20deep%20charcoal%20tones%2C%20high%20detail&width=800&height=600&seq=music-04-cover&orientation=landscape',
    category: 'music',
    categoryName: '音乐',
    author: '苏禾',
    date: '2026-06-07',
    views: 8450,
    tags: ['金曲奖', '提名', '榜单'],
    hot: false,
    filters: { style: '流行', time: '今年' },
    content: [
      { type: 'paragraph', text: '提名名单公布的当天，社交平台上讨论最多的，是一批平均年龄不到三十岁的名字。他们不再只是“新人”，而是真正拥有了代表作的音乐人。' },
      { type: 'heading', text: '一次安静而有力的换代' },
      { type: 'paragraph', text: '评审团透露，本届评选更看重作品的整体概念与完成度，而非单纯的传唱度，这也让不少独立创作人首次进入视野。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=young%20musicians%20on%20elegant%20awards%20red%20carpet%20with%20warm%20gold%20lights%2C%20ceremony%20atmosphere%2C%20sophisticated%20editorial%20photography&width=1200&height=700&seq=music-04-body&orientation=landscape', caption: '新生代音乐人集体亮相' },
      { type: 'quote', text: '“名单看起来变了，其实是华语乐坛真的走到了下一站。”——乐评人' },
      { type: 'paragraph', text: '颁奖礼将于下月举行，多组艺人已确认登台表演，被视为年度最值得期待的舞台之一。' },
    ],
  },
  {
    id: 'b5',
    title: '民谣诗人周野回归，新歌讲述一段旅途往事',
    summary: '消失三年后，周野带着一首关于远方的歌回来了。没有华丽编曲，只有一把木吉他和他一贯温和的嗓音。',
    cover: 'https://readdy.ai/api/search-image?query=lone%20acoustic%20guitar%20on%20wooden%20table%20by%20window%20with%20soft%20afternoon%20light%2C%20folk%20music%20aesthetic%2C%20warm%20earthy%20tones%2C%20minimal%20nostalgic%20mood%2C%20high%20detail&width=800&height=600&seq=music-05-cover&orientation=landscape',
    category: 'music',
    categoryName: '音乐',
    author: '阿南',
    date: '2026-06-03',
    views: 7620,
    tags: ['民谣', '回归', '新歌'],
    hot: false,
    filters: { style: '民谣', time: '本季' },
    content: [
      { type: 'paragraph', text: '三年前，周野突然从公众视野里消失。歌迷以为他不会再回来，直到这首歌悄悄上线——没有预告，没有宣传，只有一段旋律和一辆开往远方的列车。' },
      { type: 'heading', text: '远方不在终点，而在路上' },
      { type: 'paragraph', text: '歌曲记录了他徒步旅行途中的见闻，歌词朴素却温暖，像一封写给老朋友的来信。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=solitary%20traveler%20with%20backpack%20walking%20along%20countryside%20railway%20at%20golden%20hour%2C%20folk%20music%20mood%2C%20warm%20sepia%20tones%2C%20cinematic%20photography&width=1200&height=700&seq=music-05-body&orientation=landscape', caption: '旅途中的某个黄昏' },
      { type: 'quote', text: '“走了很久我才明白，我们找的从来不是终点。”——周野' },
      { type: 'paragraph', text: '不少歌迷留言说，这首歌让他们想起自己曾经想去的远方。周野也表示，新的巡演正在筹备中。' },
    ],
  },
  {
    id: 'b6',
    title: '电子音乐节阵容官宣，顶尖DJ齐聚引爆夏日',
    summary: '今年的电子音乐节公布首批阵容，国内外多组重量级DJ将同台演出，门票开售即引发抢购。',
    cover: 'https://readdy.ai/api/search-image?query=electronic%20music%20festival%20crowd%20with%20laser%20lights%20and%20glowing%20stage%2C%20night%20celebration%20atmosphere%2C%20vibrant%20orange%20and%20magenta%20beams%2C%20high%20detail&width=800&height=600&seq=music-06-cover&orientation=landscape',
    category: 'music',
    categoryName: '音乐',
    author: '橘子',
    date: '2026-05-30',
    views: 14560,
    tags: ['音乐节', '电子', '阵容'],
    hot: false,
    filters: { style: '电子', time: '本季' },
    content: [
      { type: 'paragraph', text: '首批阵容一经公布，抢票系统几乎被挤爆。对于电子乐迷来说，夏天的意义从来不只是一场演出，而是一场属于所有人的通宵狂欢。' },
      { type: 'heading', text: '一场持续到天亮的狂欢' },
      { type: 'paragraph', text: '主办方表示，今年将升级主舞台的灯光与声音系统，并首次设置沉浸式互动区，让观众真正走进音乐里。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=euphoric%20crowd%20dancing%20under%20giant%20LED%20stage%20with%20confetti%2C%20electronic%20festival%20night%2C%20vibrant%20colorful%20lights%2C%20high%20energy%20photography&width=1200&height=700&seq=music-06-body&orientation=landscape', caption: '夜色中的律动现场' },
      { type: 'quote', text: '“音乐节最好的部分，是你和陌生人一起举起手的那一刻。”——主办方' },
      { type: 'paragraph', text: '完整阵容将在下月公布，主办方提醒观众通过官方渠道购票，并注意现场安全与防晒。' },
    ],
  },
  {
    id: 'c1',
    title: '演员苏漾官宣新剧，挑战反差角色引爆期待',
    summary: '一向以温柔形象示人的苏漾，这次要演一个亦正亦邪的复杂人物。定妆照一出，评论区瞬间炸了。',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20actor%20portrait%20with%20dramatic%20studio%20lighting%2C%20cinematic%20character%20poster%20style%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20high%20detail&width=800&height=600&seq=star-01-cover&orientation=landscape',
    category: 'star',
    categoryName: '明星',
    author: '林晚',
    date: '2026-06-17',
    views: 22680,
    tags: ['新剧', '苏漾', '角色'],
    hot: true,
    filters: { gender: '男艺人', status: '当红' },
    content: [
      { type: 'paragraph', text: '定妆照发布的那一刻，很多粉丝都没认出他来。那个总演温柔男主的苏漾，这次眼神里多了锋利和危险。官宣话题迅速登上热搜。' },
      { type: 'heading', text: '走出舒适区的第一次尝试' },
      { type: 'paragraph', text: '苏漾坦言，这是他入行以来最难的角色。为了贴近人物，他提前两个月进组体验生活，甚至改变了说话的语气和走路的方式。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=actor%20in%20dark%20costume%20under%20dramatic%20moody%20lighting%2C%20character%20portrait%20photography%2C%20warm%20rim%20light%20against%20dark%20background%2C%20high%20detail&width=1200&height=700&seq=star-01-body&orientation=landscape', caption: '定妆照中的全新形象' },
      { type: 'quote', text: '“我不想一直演被喜欢的角色，我想演能让人记住的角色。”——苏漾' },
      { type: 'paragraph', text: '该剧已进入拍摄阶段，预计明年与观众见面。粉丝纷纷表示，这次真的等不及了。' },
    ],
  },
  {
    id: 'c2',
    title: '温以宁红毯造型出圈，高级感拉满被赞“行走的衣架”',
    summary: '一身简约却惊艳的礼服，让温以宁在红毯上脱颖而出。造型团队透露，整套look只用了一个配饰做点睛。',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20actress%20in%20flowing%20gown%20on%20red%20carpet%2C%20high%20fashion%20editorial%20photography%2C%20soft%20warm%20lighting%20with%20subtle%20gold%20accents%2C%20high%20detail&width=800&height=600&seq=star-02-cover&orientation=landscape',
    category: 'star',
    categoryName: '明星',
    author: '苏禾',
    date: '2026-06-14',
    views: 19840,
    tags: ['红毯', '造型', '温以宁'],
    hot: true,
    filters: { gender: '女艺人', status: '当红' },
    content: [
      { type: 'paragraph', text: '当晚的红毯上，温以宁几乎是所有镜头追逐的焦点。这套造型被时尚博主们连夜解析，关键词只有一个——高级。' },
      { type: 'heading', text: '少即是多的造型哲学' },
      { type: 'paragraph', text: '造型团队透露，整身搭配只在耳畔留了一枚细链珠宝，其余一切从简。正是这份克制，让整体气质格外突出。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=close%20up%20of%20elegant%20jewelry%20and%20fabric%20detail%20on%20high%20fashion%20gown%2C%20luxury%20editorial%20still%20life%2C%20warm%20gold%20and%20cream%20tones%2C%20high%20detail&width=1200&height=700&seq=star-02-body&orientation=landscape', caption: '细节处见质感' },
      { type: 'quote', text: '“最好的造型，是让人记住你，而不是记住衣服。”——造型师' },
      { type: 'paragraph', text: '这已经不是温以宁第一次靠红毯造型出圈。时尚圈普遍认为，她正在成为新一代的“红毯定海神针”。' },
    ],
  },
  {
    id: 'c3',
    title: '顾南舟回归综艺，幽默人设圈粉无数',
    summary: '曾经以高冷著称的顾南舟，在一档综艺里彻底放飞自我，观众直呼“原来你是这样的顾南舟”。',
    cover: 'https://readdy.ai/api/search-image?query=cheerful%20male%20celebrity%20laughing%20on%20colorful%20variety%20show%20set%2C%20entertainment%20tv%20atmosphere%2C%20warm%20playful%20colors%2C%20high%20detail&width=800&height=600&seq=star-03-cover&orientation=landscape',
    category: 'star',
    categoryName: '明星',
    author: '橘子',
    date: '2026-06-11',
    views: 17320,
    tags: ['综艺', '顾南舟', '情商'],
    hot: false,
    filters: { gender: '男艺人', status: '回归中' },
    content: [
      { type: 'paragraph', text: '节目开播第一期，顾南舟就因为一句自带笑点的发言登上热搜。很多观众表示，看完节目对他的印象完全被刷新了。' },
      { type: 'heading', text: '真实，比人设更圈粉' },
      { type: 'paragraph', text: '顾南舟在采访中说，以前的“高冷”其实只是紧张。如今的他更愿意把自己真实的一面展现出来，哪怕有点笨拙。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=celebrities%20laughing%20together%20on%20bright%20variety%20show%20stage%2C%20joyful%20entertainment%20mood%2C%20warm%20vibrant%20lighting%2C%20high%20detail&width=1200&height=700&seq=star-03-body&orientation=landscape', caption: '节目里的欢乐瞬间' },
      { type: 'quote', text: '“被喜欢当然好，但被真正了解更让我踏实。”——顾南舟' },
      { type: 'paragraph', text: '节目播出以来收视一路走高，顾南舟也被网友票选为“本季综艺最大惊喜”。' },
    ],
  },
  {
    id: 'c4',
    title: '新晋演员姜屿凭爆款剧走红，被称“宝藏男孩”',
    summary: '一部剧让默默无闻的姜屿一夜成名。走红之后，他做的第一件事却是回到剧组，继续打磨下一部作品。',
    cover: 'https://readdy.ai/api/search-image?query=young%20new%20actor%20portrait%20with%20soft%20studio%20lighting%2C%20fresh%20natural%20celebrity%20editorial%20style%2C%20warm%20neutral%20tones%2C%20high%20detail&width=800&height=600&seq=star-04-cover&orientation=landscape',
    category: 'star',
    categoryName: '明星',
    author: '林晚',
    date: '2026-06-08',
    views: 13980,
    tags: ['新晋', '走红', '姜屿'],
    hot: false,
    filters: { gender: '男艺人', status: '新晋' },
    content: [
      { type: 'paragraph', text: '几个月前，几乎没有人认识姜屿。如今，他的社交账号每天涨粉数十万，工作人员忙得连轴转。可他自己却很平静。' },
      { type: 'heading', text: '走红之后，先回到角色里' },
      { type: 'paragraph', text: '姜屿说，他最感谢的是那个愿意等他成长的角色。为了演好第二部作品，他推掉了大部分商业活动。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=young%20actor%20reading%20script%20in%20quiet%20rehearsal%20room%2C%20focused%20atmosphere%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20high%20detail&width=1200&height=700&seq=star-04-body&orientation=landscape', caption: '剧组里的安静时光' },
      { type: 'quote', text: '“红不红控制不了，演得好不好，我自己可以控制。”——姜屿' },
      { type: 'paragraph', text: '业内评价，姜屿的难得之处在于清醒。对新生代演员而言，这份清醒或许比一时的热度更珍贵。' },
    ],
  },
  {
    id: 'c5',
    title: '歌手出身的许安转型演员，首部作品收获好评',
    summary: '从舞台到镜头前，许安的转型一开始并不被看好。但这部剧播出后，观众说她“眼睛里真的有戏”。',
    cover: 'https://readdy.ai/api/search-image?query=actress%20singer%20portrait%20with%20soft%20cinematic%20lighting%2C%20elegant%20minimal%20editorial%20style%2C%20warm%20cream%20and%20charcoal%20tones%2C%20high%20detail&width=800&height=600&seq=star-05-cover&orientation=landscape',
    category: 'star',
    categoryName: '明星',
    author: '苏禾',
    date: '2026-06-04',
    views: 10230,
    tags: ['转型', '许安', '演员'],
    hot: false,
    filters: { gender: '女艺人', status: '回归中' },
    content: [
      { type: 'paragraph', text: '当许安宣布要演戏时，评论区并不友好。很多人觉得歌手跨界只会是玩票。可剧集播出后，那些质疑的声音慢慢消失了。' },
      { type: 'heading', text: '把舞台经验变成表演养分' },
      { type: 'paragraph', text: '许安坦言，多年舞台经验让她更懂情绪的控制。为了这部戏，她系统地上了半年表演课，从台词到形体一点点补齐。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=actress%20in%20thoughtful%20close%20up%20scene%20with%20emotional%20cinematic%20lighting%2C%20film%20still%20style%2C%20warm%20muted%20tones%2C%20high%20detail&width=1200&height=700&seq=star-05-body&orientation=landscape', caption: '镜头前的细腻表达' },
      { type: 'quote', text: '“我不怕被说跨界，我怕的是没有认真对待每一个角色。”——许安' },
      { type: 'paragraph', text: '目前她已确定出演第二部作品。观众期待，这个愿意沉下心来的歌手，能在演员这条路上走得更远。' },
    ],
  },
  {
    id: 'c6',
    title: '明星夫妻合体出席活动，甜蜜互动冲上热搜',
    summary: '许久未同框的两人，在某品牌活动上再度合体。一个眼神、一次搀扶，就让现场观众直呼“太甜了”。',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20celebrity%20couple%20at%20gala%20event%20with%20soft%20warm%20lights%2C%20sophisticated%20editorial%20photography%2C%20cream%20and%20gold%20tones%2C%20high%20detail&width=800&height=600&seq=star-06-cover&orientation=landscape',
    category: 'star',
    categoryName: '明星',
    author: '橘子',
    date: '2026-05-31',
    views: 16750,
    tags: ['夫妻', '同框', '热搜'],
    hot: false,
    filters: { gender: '女艺人', status: '当红' },
    content: [
      { type: 'paragraph', text: '两人已经很久没有公开同框了。当晚他们并肩走红毯的画面，第一时间就登上了热搜榜前列。' },
      { type: 'heading', text: '细水长流，才是最动人的甜' },
      { type: 'paragraph', text: '比起刻意的展示，观众更喜欢他们之间那些自然的小动作——一次不经意的搀扶，一个会心的笑。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=celebrities%20holding%20hands%20walking%20into%20elegant%20event%20hall%2C%20warm%20ambient%20lighting%2C%20romantic%20editorial%20photography%2C%20high%20detail&width=1200&height=700&seq=star-06-body&orientation=landscape', caption: '活动中的自然互动' },
      { type: 'quote', text: '“好的感情不用演，看的人都感受得到。”——网友评论' },
      { type: 'paragraph', text: '两人目前各自有作品在播，粉丝也乐见他们在事业与生活之间找到平衡。' },
    ],
  },
  {
    id: 'd1',
    title: '2026春夏穿搭趋势：低饱和色系成为主流',
    summary: '浓烈撞色退场，温柔的低饱和色系接管了这个春夏。如何把它穿得高级而不寡淡？这份指南告诉你。',
    cover: 'https://readdy.ai/api/search-image?query=minimal%20fashion%20flatlay%20with%20muted%20earth%20tone%20clothing%2C%20soft%20neutral%20palette%2C%20clean%20editorial%20styling%2C%20warm%20cream%20and%20sand%20colors%2C%20high%20detail&width=800&height=600&seq=trend-01-cover&orientation=landscape',
    category: 'trend',
    categoryName: '潮流',
    author: '阿南',
    date: '2026-06-16',
    views: 15620,
    tags: ['穿搭', '趋势', '春夏'],
    hot: true,
    filters: { field: '穿搭', season: '春夏' },
    content: [
      { type: 'paragraph', text: '今年春夏，街头最显眼的不是亮色，而是一种温柔的低饱和。米白、燕麦、雾灰、浅杏……这些颜色安静地占据了一整季的衣橱。' },
      { type: 'heading', text: '低饱和，怎么穿才不寡淡' },
      { type: 'paragraph', text: '秘诀在于层次。用不同明度的同色系叠穿，再点缀一件有质感的配饰，就能让整套造型立刻立体起来。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=model%20wearing%20muted%20tonal%20outfit%20against%20minimal%20warm%20wall%2C%20soft%20natural%20light%2C%20editorial%20fashion%20photography%2C%20neutral%20palette%2C%20high%20detail&width=1200&height=700&seq=trend-01-body&orientation=landscape', caption: '同色系叠穿的层次感' },
      { type: 'quote', text: '“颜色越安静，剪裁和质感就越重要。”——造型师' },
      { type: 'paragraph', text: '如果你还在犹豫要不要尝试，可以先从一件燕麦色针织开始。它几乎能和衣橱里的一切和平相处。' },
    ],
  },
  {
    id: 'd2',
    title: '美妆新趋势“水光肌”回归，底妆教程刷屏',
    summary: '厚重妆感不再是主流，通透的“水光肌”重新成为焦点。想要自然好气色，关键其实在护肤而不是粉底。',
    cover: 'https://readdy.ai/api/search-image?query=clean%20beauty%20flatlay%20with%20minimal%20skincare%20bottles%20and%20soft%20sponge%2C%20glowing%20dewy%20aesthetic%2C%20warm%20cream%20and%20soft%20peach%20tones%2C%20high%20detail&width=800&height=600&seq=trend-02-cover&orientation=landscape',
    category: 'trend',
    categoryName: '潮流',
    author: '苏禾',
    date: '2026-06-13',
    views: 13480,
    tags: ['美妆', '底妆', '水光肌'],
    hot: false,
    filters: { field: '美妆', season: '春夏' },
    content: [
      { type: 'paragraph', text: '打开社交平台，满屏都是“水光肌”。那种仿佛自带柔光的通透底妆，成了这个夏天最想拥有的皮肤状态。' },
      { type: 'heading', text: '好底妆，一半靠护肤' },
      { type: 'paragraph', text: '美妆师反复强调，想要水光感，先要把皮肤养好。做好保湿之后，再薄薄地上一层粉底，效果远胜厚重的遮瑕。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=close%20up%20of%20dewy%20glowing%20skin%20with%20natural%20makeup%2C%20clean%20beauty%20editorial%20photography%2C%20soft%20warm%20lighting%2C%20high%20detail&width=1200&height=700&seq=trend-02-body&orientation=landscape', caption: '通透自然的水光质感' },
      { type: 'quote', text: '“底妆不是盖住皮肤，而是让皮肤看起来像在发光。”——美妆师' },
      { type: 'paragraph', text: '搭配一把好的上妆刷，再学两三个小技巧，你也能拥有让人误以为“天生好皮肤”的妆感。' },
    ],
  },
  {
    id: 'd3',
    title: '复古运动鞋再度翻红，联名款一鞋难求',
    summary: '那些曾被放进衣柜深处的复古鞋型，如今重新占领街头。一双联名款，甚至要排队抽签才能买到。',
    cover: 'https://readdy.ai/api/search-image?query=retro%20sneakers%20on%20minimal%20concrete%20surface%2C%20streetwear%20product%20photography%2C%20warm%20neutral%20backdrop%20with%20soft%20shadows%2C%20high%20detail&width=800&height=600&seq=trend-03-cover&orientation=landscape',
    category: 'trend',
    categoryName: '潮流',
    author: '阿南',
    date: '2026-06-10',
    views: 11940,
    tags: ['球鞋', '联名', '复古'],
    hot: false,
    filters: { field: '穿搭', season: '春夏' },
    content: [
      { type: 'paragraph', text: '潮流是个圈。曾经被认为“老气”的复古跑鞋，如今成了年轻人鞋柜里的必备单品。热门联名款更是上架即空。' },
      { type: 'heading', text: '复古，为什么又流行了' },
      { type: 'paragraph', text: '答案也许在于它的百搭。复古鞋型线条柔和，既能配阔腿裤，也能搭连衣裙，几乎不挑风格。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=close%20up%20of%20vintage%20running%20shoe%20details%20with%20mesh%20and%20suede%2C%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1200&height=700&seq=trend-03-body&orientation=landscape', caption: '复古鞋型的细节质感' },
      { type: 'quote', text: '“潮流追到最后，穿得舒服、看得顺眼，才是真的赢。”——球鞋博主' },
      { type: 'paragraph', text: '如果你也想入手，建议优先考虑经典配色。它们往往比限定色更耐看，也更容易搭配。' },
    ],
  },
  {
    id: 'd4',
    title: '露营风升级“精致户外”，装备清单受追捧',
    summary: '从“能住就行”到“越精致越好”，露营正在变成一种生活方式。咖啡壶、氛围灯、折叠椅，一个都不能少。',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20glamping%20scene%20at%20golden%20hour%20with%20warm%20lights%20and%20canvas%20tent%2C%20outdoor%20lifestyle%20photography%2C%20warm%20earth%20tones%2C%20high%20detail&width=800&height=600&seq=trend-04-cover&orientation=landscape',
    category: 'trend',
    categoryName: '潮流',
    author: '橘子',
    date: '2026-06-07',
    views: 9880,
    tags: ['露营', '户外', '生活方式'],
    hot: false,
    filters: { field: '生活方式', season: '春夏' },
    content: [
      { type: 'paragraph', text: '周末的朋友圈，一半在看展，另一半在露营。而现在的露营，早已不是简单扎个帐篷那么随意了。' },
      { type: 'heading', text: '精致户外，到底精致在哪' },
      { type: 'paragraph', text: '除了基础的帐篷和睡袋，人们开始带上手冲咖啡壶、复古氛围灯和折叠桌椅，把家搬进了大自然里。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=hands%20pouring%20coffee%20by%20campfire%20with%20lanterns%20at%20dusk%2C%20cozy%20outdoor%20lifestyle%2C%20warm%20amber%20tones%2C%20high%20detail&width=1200&height=700&seq=trend-04-body&orientation=landscape', caption: '黄昏里的一杯手冲' },
      { type: 'quote', text: '“露营的意义，是把生活节奏调慢两个小时。”——户外爱好者' },
      { type: 'paragraph', text: '当然，精致的核心不是装备多贵，而是你有没有真正放下手机，去看一次落日。' },
    ],
  },
  {
    id: 'd5',
    title: '数码潮玩联名引爆，限量手办开售即售罄',
    summary: '一次看似跨界的联名，却让两边粉丝同时疯狂。限量手办上线几秒钟就被抢空，二手市场价格翻倍。',
    cover: 'https://readdy.ai/api/search-image?query=stylish%20collectible%20designer%20toy%20figure%20on%20minimal%20pedestal%2C%20playful%20modern%20product%20photography%2C%20warm%20studio%20lighting%20with%20soft%20shadow%2C%20high%20detail&width=800&height=600&seq=trend-05-cover&orientation=landscape',
    category: 'trend',
    categoryName: '潮流',
    author: '苏禾',
    date: '2026-06-04',
    views: 8740,
    tags: ['潮玩', '联名', '限量'],
    hot: false,
    filters: { field: '数码', season: '春夏' },
    content: [
      { type: 'paragraph', text: '当联名消息公布时，两个圈子的粉丝都炸了。开售那天，限量手办在几秒钟内被一抢而空，二手平台价格立刻翻倍。' },
      { type: 'heading', text: '联名，为什么总能引爆' },
      { type: 'paragraph', text: '好的联名不是简单贴个logo，而是两个品牌气质真正融合。这次的作品，把数码的冷感与潮玩的可爱结合得恰到好处。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=collectible%20toy%20figures%20displayed%20in%20warm%20lit%20shelf%2C%20modern%20collector%20room%2C%20soft%20amber%20lighting%2C%20high%20detail&width=1200&height=700&seq=trend-05-body&orientation=landscape', caption: '收藏柜里的新成员' },
      { type: 'quote', text: '“买的不是玩偶，是小时候没说出口的愿望。”——收藏者' },
      { type: 'paragraph', text: '主办方表示，后续或将推出补货计划，但限量款的稀缺性依然让它在潮玩圈持续升温。' },
    ],
  },
  {
    id: 'd6',
    title: '咖啡文化融入日常，城市咖啡馆打卡热潮再起',
    summary: '越来越多人把周末的第一件事，变成走进一家新开的咖啡馆。咖啡，正在成为年轻人新的社交方式。',
    cover: 'https://readdy.ai/api/search-image?query=minimal%20cozy%20cafe%20interior%20with%20latte%20art%20on%20wooden%20table%2C%20warm%20natural%20light%2C%20soft%20neutral%20and%20amber%20tones%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=trend-06-cover&orientation=landscape',
    category: 'trend',
    categoryName: '潮流',
    author: '阿南',
    date: '2026-06-01',
    views: 10260,
    tags: ['咖啡', '咖啡馆', '生活'],
    hot: false,
    filters: { field: '生活方式', season: '春夏' },
    content: [
      { type: 'paragraph', text: '一条安静的小巷里，新开的咖啡馆门口排起了队。人们不再只是为了喝一杯咖啡，而是为了那个属于自己的下午。' },
      { type: 'heading', text: '咖啡馆，年轻人的第三空间' },
      { type: 'paragraph', text: '在办公室和家之外，咖啡馆成了许多人放松、工作、见朋友的地方。一杯咖啡的时间，足以让生活慢下来。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=barista%20pouring%20latte%20art%20in%20sunlit%20minimal%20cafe%2C%20warm%20inviting%20atmosphere%2C%20soft%20amber%20lighting%2C%20high%20detail&width=1200&height=700&seq=trend-06-body&orientation=landscape', caption: '阳光里的那一杯拿铁' },
      { type: 'quote', text: '“咖啡馆卖的从来不只是咖啡，是一段慢下来的时光。”——店主' },
      { type: 'paragraph', text: '如果你也想开启自己的咖啡打卡地图，不妨从这个周末的清晨开始，走进一家没去过的店。' },
    ],
  },
];